module.exports = __webpack_public_path__ + "static/img/copy.e8ee8164.svg";